import { render, staticRenderFns } from "./CarKeyBoard.vue?vue&type=template&id=fad086c4&scoped=true&"
import script from "./CarKeyBoard.vue?vue&type=script&lang=js&"
export * from "./CarKeyBoard.vue?vue&type=script&lang=js&"
import style0 from "./CarKeyBoard.vue?vue&type=style&index=0&id=fad086c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad086c4",
  null
  
)

export default component.exports